import { GroupByTypeId as GroupByTypeId$1, evaluate as evaluate$1, filter as filter$1, first as first$1, make as make$1 } from '../../internal/groupBy.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const GroupByTypeId = GroupByTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * Representation of a grouped stream. This allows to filter which groups will
 * be processed. Once this is applied all groups will be processed in parallel
 * and the results will be merged in arbitrary order.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Run the function across all groups, collecting the results in an
 * arbitrary order.
 *
 * @since 2.0.0
 * @category destructors
 */
const evaluate = evaluate$1;

/**
 * Filter the groups to be processed.
 *
 * @since 2.0.0
 * @category utils
 */
const filter = filter$1;

/**
 * Only consider the first `n` groups found in the `Stream`.
 *
 * @since 2.0.0
 * @category utils
 */
const first = first$1;

/**
 * Constructs a `GroupBy` from a `Stream`.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

export { GroupByTypeId, evaluate, filter, first, make };
